module.exports = __webpack_public_path__ + "img/Airbnb-Hybrid.3771f616.jpg";